import React from 'react';
import { Field } from 'formik';

import styles from './returnsFormStyles';

import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';
import AddRemoveForm from 'buyside/components/presentation/Form/AddRemoveForm/addRemoveForm';
import DocumentsForm from 'buyside/components/presentation/Form/DocumentsForm/documentsForm';
import SingleCheckboxField from 'buyside/components/presentation/Form/Field/SingleCheckboxField/singleCheckboxField';

const { indices } = require('buyside/util/constantsFromRails.json');

// NOTE: make sure to update the appropriate schema in util/fundProfileShowPageValidationSchemata

const ReturnsForm = ({ values }) => {
  const fundName = values.fundProfile.name;

  const renderReturn = (retPath, ret, idx) => (
    <div>
      {ret.employerBenchmark ? (
        <>
          <div className={styles.returnStrategyName}>
            <p>{fundName}</p>
            {fundName === ret.benchmark ? null : <p>{ret.benchmark}</p>}
          </div>
          <Field
            component={InputField}
            placeholder="Enter a Strategy"
            name={retPath + '.benchmark'}
          />
        </>
      ) : (
        <Field
          component={InputField}
          label=""
          name={retPath + '.benchmark'}
          options={indices}
          placeholder="Select Benchmark..."
          type="select"
        />
      )}
      {idx === 0 ? null : (
        <Field
          component={SingleCheckboxField}
          label="Additional Fund Strategy"
          name={retPath + '.employerBenchmark'}
        />
      )}
      <div className={styles.returnFields}>
        <Field component={InputField} name={retPath + '.ytd'} label="YTD" />
        <Field component={InputField} name={retPath + '.ltm'} label="LTM" />
        <Field component={InputField} name={retPath + '.oneYear'} label="1 Year" />
        <Field component={InputField} name={retPath + '.threeYear'} label="3 Year" />
        <Field component={InputField} name={retPath + '.fiveYear'} label="5 Year" />
        <Field component={InputField} name={retPath + '.sevenYear'} label="7 Year" />
        <Field component={InputField} name={retPath + '.tenYear'} label="10 Year" />
        <Field component={InputField} name={retPath + '.sinceInception'} label="Inception" />
      </div>
    </div>
  );

  return (
    <div>
      <AddRemoveForm
        title="Returns/Benchmarks"
        attr="fundProfile.returns"
        renderItem={renderReturn}
        itemName="Benchmark"
        blankItem={{
          benchmark: '',
          employerBenchmark: false,
          ytd: '',
          ltm: '',
          oneYear: '',
          threeYear: '',
          fiveYear: '',
          sevenYear: '',
          tenYear: '',
          sinceInception: ''
        }}
        cannotRemoveFirstItem
      />
      <div className={styles.returnsFormValid}>
        <Field
          component={InputField}
          name="fundProfile.returnsUpdatedDate"
          type="date"
          label="Returns Valid As Of:"
        />
      </div>
      <DocumentsForm
        title="Supporting Documents"
        attr="fundProfile.returnsDocuments"
        withDescription
        withMargin
      />
    </div>
  );
};

export default ReturnsForm;
